import React from 'react';
import '../styles/OrganismesPartenaires.css';

// Import des logos
import assuranceMaladieLogo from '../assets/assurance-maladie.png';
import assuranceRetraiteLogo from '../assets/assurance-retraite.jpg';
import caf from '../assets/alloc.png';
import financePubliqueLogo from '../assets/finance-publique.png';
import franceRenovLogo from '../assets/france-renov.png';
import franceTitreLogo from '../assets/france-titre.png';
import franceTravailLogo from '../assets/france-travail.png';
import impots from '../assets/urssaf.png';
import msaLogo from '../assets/msa.png';
import pointJusticeLogo from '../assets/point-justice.png';
import urssafLogo from '../assets/urssaf.png';
import poste from '../assets/laposte.png'

function OrganismesPartenaires() {
  const organismes = [
    {
      nom: 'CAF',
      logo: caf,
      description: 'Caisse d\'Allocations Familiales'
    },
    {
      nom: 'France Travail',
      logo: franceTravailLogo,
      description: 'Pôle Emploi'
    },
    {
      nom: 'Assurance Maladie',
      logo: assuranceMaladieLogo,
      description: 'CPAM - Sécurité Sociale'
    },
    {
      nom: 'France Titres',
      logo: franceTitreLogo,
      description: 'Titres sécurisés'
    },
    {
      nom: 'Impots.gouv',
      logo: impots,
      description: 'Direction Générale des Finances Publiques'
    },
    {
      nom: 'Finances Publiques',
      logo: financePubliqueLogo,
      description: 'Services fiscaux'
    },
    {
      nom: 'Assurance Retraite',
      logo: assuranceRetraiteLogo,
      description: 'Retraite et pension'
    },
    {
      nom: 'URSSAF',
      logo: urssafLogo,
      description: 'Cotisations sociales'
    },
    {
      nom: 'MSA',
      logo: msaLogo,
      description: 'Mutualité Sociale Agricole'
    },
    {
      nom: 'France Rénov',
      logo: franceRenovLogo,
      description: 'Rénovation énergétique'
    },
    {
      nom: 'Point Justice',
      logo: pointJusticeLogo,
      description: 'Accès au droit'
    },
     {
      nom: 'La Poste',
      logo: poste,
      description: 'LaPoste'
    }
  ];

  return (
    <section className="organismes-partenaires">
      <div className="container">
        <h2>Organismes pour lesquels nous vous accompagnons</h2>
        <p className="section-description">
          Nous vous aidons dans vos démarches auprès de nombreux organismes administratifs
        </p>
        
        <div className="carousel-container">
          <div className="carousel-track">
            {/* Premier set de logos */}
            {organismes.map((org, index) => (
              <div key={`org-1-${index}`} className="carousel-item">
                <div className="logo-wrapper">
                  <img src={org.logo} alt={org.nom} />
                </div>
                <p className="organisme-nom">{org.nom}</p>
              </div>
            ))}
            {/* Duplication pour effet infini */}
            {organismes.map((org, index) => (
              <div key={`org-2-${index}`} className="carousel-item">
                <div className="logo-wrapper">
                  <img src={org.logo} alt={org.nom} />
                </div>
                <p className="organisme-nom">{org.nom}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default OrganismesPartenaires;